module.exports = __webpack_public_path__ + "static/media/53048572_2452963678112142_1664228225800208384_o.c5eadd07.jpg";